import React from 'react';
import CrmSnapshotList from './list';
import { Route, Routes } from 'react-router-dom';

export default function CrmSnapshotView() {
    return (
        <Routes>
            <Route path='/' exact element={<CrmSnapshotList />} />
        </Routes>
    );
}
